import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarComponent from "./NavbarComponent";
import Footer from "./Footer";
import { Button, Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { TbBrandX } from "react-icons/tb"; // For the X (Twitter) icon
import { FaTimes } from 'react-icons/fa';
import API_URLS from "./apiConfig";

const Careers = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    qualification: '',
    city: '',
    coverLetter: '',
    resume: null,
  });

  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { id } = useParams();
  const { pagename } = useParams();
  const defaultlang = API_URLS.defaultLang;

  useEffect(() => {
    axios
      .get(API_URLS.getAllDetails+`/${pagename}/${id}/${defaultlang}`)
      .then((response) => {
        setApiData(response.data);
        console.log(response.data);
        setLoading(false);
        // Set a delay of 5 seconds before appending the button
        const timer = setTimeout(() => {
          const divElement = document.getElementById('targetDiv');
          if (divElement) {

            // Create the button element
            const button = document.createElement('button');
            button.textContent = response.data.career_form.form_title_text;

            // Add classes to the button
            button.classList.add('viewmore-btn', 'btn', 'btn-primary');

            // Insert the SVG code as a string into the button's innerHTML
            button.innerHTML = `
              ${response.data.career_form.form_title_text}
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 48 48" fill="none">
                <rect width="42" height="42" fill="none"></rect>
                <path d="M16 32L32 16M32 16H20M32 16V28" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              `; // Add text before the SVG

            // Add an onClick event handler to the button
            button.onclick = () => setShowModal(true); // Will trigger the modal

            // Append the button to the div
            divElement.appendChild(button);
          }
        }, 5000); // 5000 ms = 5 seconds  
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError("Failed to fetch data.");
        setLoading(false);
      });
  }, [pagename, id, defaultlang]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const submissionData = new FormData();
    submissionData.append("name", formData.name);
    submissionData.append("email", formData.email);
    submissionData.append("mobile", formData.mobile);
    submissionData.append("qualification", formData.qualification);
    submissionData.append("city", formData.city);
    submissionData.append("cover_letter", formData.coverLetter);
    submissionData.append("resume", formData.resume);

    try {
      const response = await axios.post(
        API_URLS.postCareerFormSubmit,
        submissionData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setSuccessMessage("Your application has been submitted successfully!");
      setFormData({
        name: '',
        email: '',
        mobile: '',
        qualification: '',
        city: '',
        coverLetter: '',
        resume: null,
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      setError("Failed to submit the application. Please try again.");
    }
  };

  return (
    <>
      <NavbarComponent />
      <div className="Careers">
        <div className="container">
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>{error}</p>
          ) : (
            <>
              <h1 className="Careers-header">{apiData.title}</h1>
              <div
                className="content"
                dangerouslySetInnerHTML={{ __html: apiData.content }}
              ></div>

              {/*<Button className="viewmore-btn" onClick={() => setShowModal(true)}>
                Open Application Form
              </Button>*/}

              <Modal
                id="applyModal"
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                centered
              >
                <Modal.Header 
                  style={{ position: 'relative', background: '#060606', borderBottom: 'none' }} // To position closeButton properly
                >
                  <Modal.Title>{apiData.career_form.form_title_text}</Modal.Title>
                  <button
                    type="button"
                    className="btn-close"
                    style={{
                      color: '#ff5733',  // Change to your desired color
                      position: 'absolute',
                      top: '20px',
                      right: '20px',
                      border: 'none',
                      background: 'transparent',
                      fontSize: '1.5rem',
                      zIndex: 1,
                      fontWeight: 600,
                    }}
                    onClick={() => setShowModal(false)}
                  >
                   <FaTimes />
                  </button>
                </Modal.Header>
                <Modal.Body>
                  {/*<h2 className="Careers-header" style={{ marginTop: "20px" }}>
                    {apiData.career_form.form_title_text}
                  </h2>*/}
                  {successMessage && <p className="text-success">{successMessage}</p>}
                  {error && <p className="text-danger">{error}</p>}
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label>{apiData.career_form.name.label_text}</label>
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder={apiData.career_form.name.placeholder}
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>{apiData.career_form.email.label_text}</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder={apiData.career_form.email.placeholder}
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>{apiData.career_form.mobile.label_text}</label>
                        <input
                          type="text"
                          name="mobile"
                          className="form-control"
                          placeholder={apiData.career_form.mobile.placeholder}
                          value={formData.mobile}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>{apiData.career_form.qualification.label_text}</label>
                        <input
                          type="text"
                          name="qualification"
                          className="form-control"
                          placeholder={apiData.career_form.qualification.placeholder}
                          value={formData.qualification}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>{apiData.career_form.city.label_text}</label>
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          placeholder={apiData.career_form.city.placeholder}
                          value={formData.city}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>{apiData.career_form.file.label_text}</label>
                        <input
                          type="file"
                          name="resume"
                          className="form-control"
                          onChange={handleFileChange}
                          required
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <label>{apiData.career_form.cover_letter.label_text}</label>
                        <textarea
                          name="coverLetter"
                          className="form-control"
                          placeholder={apiData.career_form.cover_letter.placeholder}
                          value={formData.coverLetter}
                          onChange={handleInputChange}
                          rows="4"
                          required
                        ></textarea>
                      </div>
                      <div className="form-group col-md-12">
                        <Button className="viewmore-btn" type="submit">
                          Submit
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="42"
                            height="42"
                            viewBox="0 0 48 48"
                            fill="none"
                          >
                            <rect width="42" height="42" fill="none" />
                            <path
                              d="M16 32L32 16M32 16H20M32 16V28"
                              stroke="#fff"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                      </div>
                    </div>
                  </form>
                </Modal.Body>
              </Modal>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Careers;
